export const AssessmentActionBarEN = {
    "assessmentActionBar": {
        "tab": {
            "detail":"Detail",
        },
        "item": {
            "delete": "Delete",
            "history": "History",
            "update": "Update",
            "approval": "Approval"
        }
    }
}